import { v4 as uuidv4 } from "uuid";

/**
 * Generates a RFC4122 version 4 UUID.
 * Uses the industry-standard uuid library for reliable UUID generation.
 */
export const generateUUID = (): string => {
  return uuidv4();
};
